import KNB from '@wmfe/mach-pro-knb';
import { getCSDomainHost } from '@/src/utils/host';
import { getAutoRefundJudgeInfo, init, riderCanRedirectReport } from './api';
import { EnumLxPositionName, EnumPageStatus } from './lib/constant';
import { checkNeedLogin } from './lib/util';
import { IOrderButton, RiderRedirectParams } from './type';
import { lxClickReport } from './lib/lx';
import { CustomerCid } from './contant';
import { IsClientTypeB } from './base';

const { statusBarHeight, navigationBarHeight } = Mach.env;
const Router = Mach.requireModule('Router');

// 获取 queryString
const getQueryStringByParams = (params: any = null) => {
  const { path, query } = params || {};

  const paramsString = Object.keys(query || {})
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query?.[key] || '')}`)
    .join('&');

  return `${path}?${paramsString}`;
};

// 获取 region locale cityId
export const getRegionLocal = () => {
  try {
    const SLMPI18N = Mach.requireModule('Intl');
    const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {};
    // 商家端的region和locale不是通过定位拿到的，而是传过来的
    // todo-why:重要，商家端打开H5时候，region和locale获取方式还和C端一样吗？
    if (IsClientTypeB()) {
      const { region, cityId } = Mach.env.schemeParams || {};
      console.log('-region,cityId-', region, cityId);
      return { region, locale, cityId };
    } else {
      const SLCompass = Mach.requireModule('SLCompass');
      const { region, cityId } = SLCompass.getCompassInfo() || {};
      return { region, locale, cityId };
    }
  } catch (error) {
    // 异常上报
    return { region: '', locale: '', cityId: '' };
  }
};

// 解析 JSON 字符串，如果解析失败，返回空对象
export const JSONParse = (value: string) => {
  try {
    return JSON.parse(value || '{}') || {};
  } catch (error) {
    return {};
  }
};

const getEnvIsProd = () => {
  const SLCommon = Mach.requireModule('SLCommon');
  const { env } = SLCommon?.getEnv?.() || {};
  const isProd = !Mach.env.isDebug || env === 'Stage' || env === 'Prod';
  console.log('env', env);
  return isProd;
};

// 获取 env 与 swimlane
const getEnvAndSwimlane = () => {
  const SLCommon = Mach.requireModule('SLCommon');
  const { env = 'Prod', swimlane } = SLCommon?.getEnv?.() || {};
  console.log('SLCommon?.getEnv?.()', SLCommon?.getEnv?.());
  return { env, swimlane };
};

// 根据环境获取客服 host
export const getPageHost = () => getCSDomainHost();

// CBD 三端协议映射
const APP_NAME_MAP = {
  Sailor: 'sailorc', // C 端
  SailorPartner: 'sailorpartner', // B 端商家管理版
  SailorMerchant: 'sailorb', // B 端商家Pos版
  SailorCourier: 'sailord', // D 端
  osg_rider: 'kcourier', //小象骑手端
};

// 获取跳转协议头
export const getProtocol = () => {
  const { appName } = Mach.env || {};
  const protocol = APP_NAME_MAP?.[appName];
  if (!protocol) {
    // todo-why:告警，并使用C端兜底
    return APP_NAME_MAP.Sailor;
  }
  return protocol;
};

export const getDomainName = () => {
  const { appName } = Mach.env || {};
  return appName === 'osg_rider' ? 'www.keemart.com' : 'keeta.com';
};

// // CBD 三端会话中，IM返回地址映射
// const MACH_CHAT_BACK_PAGE_MAP = {
//   Sailor: 'mine', // C 端
//   SailorPartner: 'xxx', // B 端商家管理版  todo-why：待补充
//   SailorMerchant: 'xxx', // B 端商家Pos版  todo-why：待补充
//   SailorCourier: 'xxx', // D 端  todo-why：待补充
// };

// // CBD 三端会话中，获取IM返回地址映射
// const getMachChatBackPage = () => {
//   const { appName } = Mach.env || {};
//   const page = MACH_CHAT_BACK_PAGE_MAP?.[appName];
//   if (!page) {
//     // todo-why:告警，并使用C端兜底
//     return MACH_CHAT_BACK_PAGE_MAP.Sailor;
//   }
//   return MACH_CHAT_BACK_PAGE_MAP?.[appName];
// };

function getDeviceInfo() {
  return new Promise((resolve, reject) => {
    KNB.getDeviceInfo({
      sceneToken: '*', //受隐私合规中长期方案影响，IOS需要新增sceneToken字段，安卓不需要，权限名称为 IDFA
      success(data) {
        resolve(data);
      },
      fail(err) {
        reject(err);
      },
    });
  });
}

// 获取设备语言
export const getDeviceLanguage = async () => {
  let language = '';
  try {
    const result: any = await getDeviceInfo();
    language = result?.language;
  } catch {
    // do nothing
  }
  return language;
};

// 获取请求后端的 header 参数
export const getReqHeaderParams = async () => {
  const { region, locale, cityId } = getRegionLocal();
  const { visitInfo } = globalThis?.customerGlobalState || {};
  const deviceLanguage = await getDeviceLanguage();
  const { visitId } = visitInfo || {};
  return {
    region,
    locale,
    cityId,
    visitid: visitId,
    deviceLanguage,
  };
};

// 上报主包业务异常
export const reportBusinessException = (category, detail?: any, tags?: any, type = 'normal') => {
  try {
    if (!category) {
      return;
    }
    const Raptor = Mach.requireModule('Raptor');
    Raptor?.reportBusinessException(category, JSON.stringify(detail || {}), { ...tags, type });
  } catch (error) {
    console.log('reportBusinessException-error', error);
  }
};

// 上报缺失from异常
export const reportWarn = (category) => {
  reportBusinessException(`【客服】${category}`, {}, { type: 'normal' });
};

// 从客服 mach 跳转到客服H5
export const toH5FromMachCS = (search: { from: string; bizline?: string; }, params: any = null, machChatPage = '') => {
  const host = getPageHost();
  const { from, bizline } = search || {};
  if (!from) reportWarn('toH5FromMachCS 缺少from');
  // 【骑手端改造】这里from=waimai_waimai_home要动态调整，遵循SPA原则，from_mach_cs=1也要动态区分，用于H5回退判断,machchatpage同理
  const { appName } = Mach.env || {};
  let baseUrl = `${host}/init.html?from=${from}&from_mach_cs=${appName}${machChatPage ? `&machchat=1&machchatpage=${machChatPage}` : ''
  }${bizline ? `&bizline=${bizline}` : ''}`;

  if (baseUrl.indexOf('?') !== -1) {
    baseUrl = `${baseUrl}&sheight=${statusBarHeight}&nheight=${navigationBarHeight}`;
  } else {
    baseUrl = `${baseUrl}?sheight=${statusBarHeight}&nheight=${navigationBarHeight}`;
  }

  const { swimlane } = getEnvAndSwimlane() || {};
  // 如果泳道存在，打开H5的参数上加上泳道
  if (swimlane?.name && params?.query) {
    params.query.swimlane = swimlane?.name;
  }

  const queryString = getQueryStringByParams(params);

  let directUrl = `${getProtocol()}://keeta.com/browser?noswipeback=1&notitlebar=1&inner_url=${encodeURIComponent(
    `${baseUrl}#/${queryString}`
  )}`;

  // 小象骑手端跳转
  if (Mach.env.appName === 'osg_rider') {
    directUrl = `${getProtocol()}://www.keemart.com/web?noswipeback=1&notitlebar=1&url=${encodeURIComponent(
      `${baseUrl}#/${queryString}`
    )}`;
  }
  // console.log('directUrl', directUrl);
  Router.navigateToForResult(
    directUrl,
    null,
    () => { }
  );
};

// D 端异常上报
export const openRiderExceptionReport = async (faq, orderId, needRiderExceptionReport: boolean, from) => {
  try {
    const {
      faqId, faqDisplayName, orderRegion, bizline, visitId
    } = faq || {};
    if (orderId && faqId) {
      const params: RiderRedirectParams = {
        faqId,
        deliveryTaskId: orderId,
      };
      // const { ext } = store.state.globalParams.visitInfo || {};
      const { ext } = Mach.env.schemeParams || {};
      const { longitude, latitude } = JSONParse(ext || '{}');
      if (longitude && latitude) {
        params.longitude = longitude;
        params.latitude = latitude;
      } else {
        reportBusinessException('【客服】骑手端异常上报-获取经纬度异常', JSON.stringify({ longitude, latitude }), { type: 'normal' });
      }
      const res: any = await riderCanRedirectReport(params, orderRegion);
      const { redirect, redirectUrl } = res || {};
      // 埋点数据
      const lxObj = {
        classify_name: faqDisplayName,
        question_name: faqDisplayName,
        event_name: '订单常见问题点击',
        order_id: orderId,
        need_rider_exception_report: needRiderExceptionReport, // 新增D端标记，请求异常上报接口
        position_name: EnumLxPositionName.PreSuggest,
        lxOrderStatus: faq?.lxOrderStatus, // 灵犀埋点使用
        extends: {
          params: JSON.stringify(params),
          result: JSON.stringify(res),
        },
        bizline,
        visitId,
        from,
      };
      if (redirect && redirectUrl) {
        // 埋点信息-这里可以使用固定的 bid，这里一定会是订单页面触发
        lxClickReport(CustomerCid.OrderPage, 'b_oversea_helpcenter_8nxxlt4k_mc', {
          ...lxObj,
          order_type: 'D端异常上报',
          faq_click_type: 'D端异常上报', // 订单类型先为"D端异常上报"
        });
        Router.navigateTo(redirectUrl, {}, () => { });
        return true;
      }
    } else {
      reportBusinessException('【客服】骑手端异常上报-orderId && faqId异常', JSON.stringify({ orderId, faqId }), { type: 'normal' });
    }
  } catch (error) {
    reportBusinessException('【客服】骑手端异常上报-功能函数异常', JSON.stringify({ error }), { type: 'normal' });
  }
};

// 防抖
export function debounce(fn, timeout = 300) {
  let timer;
  return function (this, ...args) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, timeout);
  };
}

// 节流
export function throttle(fn, wait = 300) {
  let lastTime = 0;
  return function (this, ...args) {
    const now = +new Date();
    if (now - lastTime > wait) {
      lastTime = now;
      fn.apply(this, args);
    }
  };
}

/**
 * orderId：用于支持查询是否已提交过工单
 */
export const onFaqClick = throttle(async (faq, from: string, fromOrder = false, orderId?) => {
  const {
    firstFaqName,
    secondFaqName,
    faqDisplayName,
    isEndNode,
    faqSearchKey = '',
    visitId = '',
    bizline,
    faqId,
    needAutoRefundJudge,
    needRiderExceptionReport,
    needJumpKeemartPage,
    keemartPageUrl,
    robotChat,
    llmChat,
    orderRegion,
    pageName
  } = faq;

  // 小象页面跳转
  if (needJumpKeemartPage && keemartPageUrl) {
    Router.navigateTo(keemartPageUrl, {}, () => { });
    return;
  }
  const eventId = pageName === 'order' ? 'b_oversea_helpcenter_8nxxlt4k_mc' : 'b_oversea_helpcenter_9f6m839g_mc';

  // 埋点信息
  const lxInfo: any = {
    classify_name: faqDisplayName,
    event_name: '订单常见问题点击',
    question_name: faqDisplayName,
    order_id: orderId,
    faqId,
    need_auto_refund_judge: needAutoRefundJudge,
    need_rider_exception_report: needRiderExceptionReport, // 新增D端标记，请求异常上报接口
    lxOrderStatus: faq?.lxOrderStatus, // 灵犀埋点使用
    visitId,
    from,
    bizline,
  };

  // 增加自动化退赔判责逻辑
  if (needAutoRefundJudge) {
    try {
      if (orderId && faqId) {
        const res: any = await getAutoRefundJudgeInfo({
          orderViewId: orderId,
          faqId,
        }, orderRegion);
        const { clickUrlType, clickUrl } = res || {}; // 注意：这里与H5不同，$post 拿到的就是data，不是res.data，取值要注意
        // 埋点数据
        if (clickUrlType && clickUrl) {
          lxClickReport(CustomerCid.OrderPage, eventId, {
            ...lxInfo,
            order_type: 'C端自动化退赔',
            faq_click_type: 'C端自动化退赔',
            extends: {
              faqId,
              result: JSON.stringify(res),
            },
          });
          Router.navigateTo(clickUrl, {}, () => { });
          return;
        }
      } else {
        // 后续TODO，没有 orderId 和 faqId 时，加个告警
      }
    } catch (error) {
      console.log(error);
    }
  }

  const { appName } = Mach.env || {};
  // D端异常上报场景
  // 条件：骑手端+后端标记要跳转+faqId与orderId存在时，请求D端接口，确定是否要跳转
  if (appName === 'SailorCourier' && needRiderExceptionReport) {
    const openResult = await openRiderExceptionReport(faq, orderId, needRiderExceptionReport, from);
    if (openResult) {
      return;
    }
  }

  const { ext } = Mach.env.schemeParams || {};
  // 直接进入机器人会话
  if (robotChat || llmChat) {
    const query: any = {
      firstFaqName,
      secondFaqName,
      faqSearchKey,
      faqDisplayName,
      fromOrder: fromOrder ? 'true' : undefined,
      orderId: orderId || '',
      faqId: JSONParse(faqSearchKey)?.faqRefId || '',
      visitId,
      ext, // 骑手端使用
      // 无需，在H5中，从 faqSearchKey 中获取
      // userFaqId: JSONParse(faqSearchKey)?.faqId || '', // 机器人会话多增加一个userFaqId，数字格式，在 createChat 时候传给后端
    };
    if (robotChat) {
      query.robotChat = 'true';
      lxInfo.faq_click_type = '规则机器人';
    } else if (llmChat) {
      query.llmChat = 'true';
      lxInfo.faq_click_type = '大模型';
    }
    lxClickReport(CustomerCid.OrderPage, eventId, lxInfo);
    const directionCB = () => toH5FromMachCS({ from, bizline }, {
      path: 'chat',
      query,
    });
    checkNeedLogin(directionCB);
    return;
  }

  if (isEndNode) {
    if (!from) reportWarn('onFaqClick 缺少from');
    lxClickReport(CustomerCid.OrderPage, eventId, {
      ...lxInfo,
      event_name: 'FAQ末级节点点击埋点',
      faq_click_type: '末级节点点击'
    });
    toH5FromMachCS({ from, bizline }, {
      path: 'answer',
      query: {
        firstFaqName,
        secondFaqName,
        faqSearchKey,
        fromOrder: fromOrder ? 'true' : undefined,
        title: faqDisplayName,
        orderId: orderId || '',
        visitId,
        ext, // 骑手端使用
        orderRegion,
      },
    });
  } else {
    lxClickReport(CustomerCid.OrderPage, eventId, {
      ...lxInfo,
      event_name: 'FAQ二级节点点击',
      faq_click_type: 'FAQ二级节点点击'
    });
    Router.navigateTo(
      `${getProtocol()}://${getDomainName()}/machpro?mach_bundle_name=mach_pro_sailor_c_customer_service_question&from=${from}`,
      {
        faqSearchKey,
        title: faqDisplayName,
        fromOrder: fromOrder ? 'true' : undefined,
        orderId: orderId || '',
        visitId,
        bizline,
        orderRegion,
      },
      () => { }
    );
  }
}, 1500);

// 打开链接类型按钮-链接地址
export const openDirectUrl = (button) => {
  const { url, needLogin } = button || {};
  if (!url) return;
  const { config } = JSONParse(url) || {};
  const finalUrl = config?.find((item: any) => item?.type === 'Mobile')?.url ?? '';
  if (!finalUrl) return;
  // 如果需要登录，但还没有登录，需要调用登录能力
  if (needLogin && checkNeedLogin()) {
    return;
  }
  Router.navigateTo(finalUrl);
};

// 得到与配置台相互匹配的 type 类型
// export const getDeviceType = () => {
//   // todo-why：【商家端改造】会用到
//   // if (appInfo?.isPc) return "PC";
//   // return appInfo?.isPartnerPos ? "POS" : "Mobile";
//   return 'Mobile';
// }

export const getDeviceType = () => 'Mobile';

// 获取有效的 buttonList, 自助按钮类型为跳转链接形式时，如果未获取到链接，则自助按钮不展示
export const getEffectiveButtonList = (list: Array<IOrderButton>) => {
  try {
    const result = list?.filter((item: IOrderButton) => {
      const { config } = JSONParse(item?.button?.url || '{}') || {};
      const deviceType = getDeviceType();
      const redirectUrl = config?.find((it: any) => it?.type === deviceType)?.url ?? '';
      return !(item?.button?.type === 'redirect' && !redirectUrl);
    }) || [];
    return result || [];
  } catch (error) {
    return list;
  }
};

// 图片链接替换 's3-ap-hongkong.mykeeta.com' 为 's3-ap-hongkong.mykeeta.net'
export const replaceImageUrl = (url: string) => {
  const oldDomainList = ['s3-ap-hongkong.mykeeta.com', 's3-ap-hongkong.myKeeTa.com'];
  const newDomain = 's3-ap-hongkong.mykeeta.net';
  const targetOldDomain = oldDomainList.find((item) => url?.includes(item));
  if (targetOldDomain) {
    const newUrl = url?.replace(targetOldDomain, newDomain);
    return newUrl;
  }
  return url;
};

// 二级页面改造-新增
// 二级页面重构新增

const initError = () => EnumPageStatus.Fail;

export const getInitialData = async (orderId, from, locale, ext) => {
  try {
    const { locale: argLocale } = getRegionLocal();
    // todo - why：如果 from 不存在，需要上报告警
    const params: any = {
      // todo-why：这里要好好验证
      appkey: from || 'waimai_waimai_home',
      language: locale || argLocale,
      orderId,
      // bizline: EnumBizLine.KEETA, // init接口不需要bizline
    };
    if (ext) {
      params.ext = ext;
    }
    const result = await init(params);
    return result;
  } catch {
    return initError();
  }
};

export const getParamsFromInnerUrl = (url: string) => {
  try {
    if (!url) return {};
    const result = {};
    const params = url?.split('?')?.[1]?.split('&');
    params?.forEach((item) => {
      const [key, value] = item.split('=');
      result[key] = decodeURIComponent(value);
    });
    return result || {};
  } catch (err) {
    console.log(err);
  }
};

// 二级页使用，与一级页相同，后续一级页也可以使用该方法
export const getQueryInfo = (result, visitInfo) => {
  const {
    protocol, isAnonymous, chatDTO, questionDTO
  } = result;
  const {
    orderId,
    ext,
    bpcJumpTo,
    bizline,
    visitId
  } = visitInfo || {};
  const { faqDisplayName = '', faqSearchKey = '' } = questionDTO || {};
  const { chatId } = chatDTO || {};
  try {
    const query: any = {
      skipLoginCheck: protocol === 'chat' && isAnonymous ? '1' : '',
      bpcJumpTo,
      bizline,
    };
    if (chatId) query.chatId = chatId;
    // if (chatScene) query.chatScene = chatScene;
    if (faqSearchKey) query.faqSearchKey = faqSearchKey;
    if (faqDisplayName) query.faqDisplayName = faqDisplayName;
    if (orderId) query.orderId = orderId;
    if (ext) query.ext = ext;
    if (bpcJumpTo) query.bpcJumpTo = bpcJumpTo;
    if (visitId) query.visitId = visitId;
    if (bizline) query.bizline = bizline;
    return query;
  } catch (error) {
    return {};
  }
};

// 连续返回上一级
export const continuousBack = () => {
  Mach.on('pageDidAppear', () => {
    KNB.getResult({
      success(resp) {
        if (resp?.resultData === 'native-back') {
          Mach.requireModule('Router').navigateBack();
        }
      },
      fail(err) {
        console.log('getResult error', err);
      },
    });
  });
};

// i18n时间治理SDK 兜底城市id统一收口; 兜底香港
export const DEFAULT_CITY_ID = '810001';
export const SDK_FORMAT_STR = 'yyyy-MM-dd HH:mm:ss'; // machpro SDK 年月日 时分秒 转换格式

/**
 * /时间戳转成时间字符串
 * 注意：这里Android端有bug，阿语格式化有问题，该函数暂不使用，后端对时间格式化之后返回给前端
 */
export const getI18nFormattedDateTime = async (
  cityId: string | number,
  timestamp: number | string,
  pattern: any = ''
): Promise<string> => {
  if (!timestamp) return '';
  try {
    const SLMPI18N = Mach.requireModule('Intl');
    const res = await SLMPI18N?.formatDateTimeByCityId({
      cityId: String(cityId || DEFAULT_CITY_ID),
      timestamp: Number(timestamp),
      pattern: pattern || SDK_FORMAT_STR,
    });
    return res;
  } catch (error) {
    console.log('getI18nFormattedDateTime error', error);
    return '';
  }
};
